import createIcon from '../../createIcon';

/**
 * @component @name Fort
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjEgM1Y1SDE5VjNIMTdWNUgxNVYzSDEzVjdMMTUgOVYxMEg5VjlMMTEgN1YzSDlWNUg3VjNINVY1SDNWM0gxVjdMMyA5VjE1TDEgMTdWMjFIMTBWMThDMTAgMTYuOSAxMC45IDE2IDEyIDE2QzEzLjEgMTYgMTQgMTYuOSAxNCAxOFYyMUgyM1YxN0wyMSAxNVY5TDIzIDdWM0gyMVoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Fort = createIcon('Fort', [
  [
    'path',
    {
      d: 'M21 3V5H19V3H17V5H15V3H13V7L15 9V10H9V9L11 7V3H9V5H7V3H5V5H3V3H1V7L3 9V15L1 17V21H10V18C10 16.9 10.9 16 12 16C13.1 16 14 16.9 14 18V21H23V17L21 15V9L23 7V3H21Z',
      key: 'n13m7f',
    },
  ],
]);

export default Fort;
